import React, { useState } from "react";
import { useI18n } from "@/i18n/I18nContext";
import MarketingShell from "./MarketingShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";
import { CONTACT } from "@/lib/contact";
import api from "@/lib/api";

export default function Contact() {
    const { t } = useI18n();
    const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
    const [busy, setBusy] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/contact", form);
            toast.success(t("contact.sent"));
            setForm({ name: "", email: "", subject: "", message: "" });
        } catch (err) {
            toast.error(err?.response?.data?.detail || t("contact.failed"));
        } finally {
            setBusy(false);
        }
    };
    return (
        <MarketingShell>
            <section className="mx-auto grid max-w-6xl gap-12 px-6 py-16 md:grid-cols-2 md:py-24">
                <div>
                    <h1 className="font-serif text-4xl font-bold tracking-tighter md:text-5xl">{t("nav.contact")}</h1>
                    <p className="mt-4 text-muted-foreground">{t("contact.intro")}</p>
                    <div className="mt-8 space-y-4 text-sm">
                        <a href={`mailto:${CONTACT.email}`} data-testid="contact-info-email" className="flex items-center gap-3 hover:text-accent"><Mail className="h-5 w-5 text-accent" /><span>{CONTACT.email}</span></a>
                        <a href={CONTACT.phoneHref} data-testid="contact-info-phone" className="flex items-center gap-3 hover:text-accent"><Phone className="h-5 w-5 text-accent" /><span>{CONTACT.phone}</span></a>
                        <a href={CONTACT.mapsHref} target="_blank" rel="noreferrer" data-testid="contact-info-address" className="flex items-center gap-3 hover:text-accent"><MapPin className="h-5 w-5 text-accent" /><span>{CONTACT.address}</span></a>
                    </div>
                </div>
                <form onSubmit={submit} className="rounded-3xl border border-border/70 bg-card p-8" data-testid="contact-form">
                    <div className="space-y-4">
                        <div><Label>{t("common.name")}</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" className="mt-1.5" /></div>
                        <div><Label>{t("common.email")}</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" className="mt-1.5" /></div>
                        <div><Label>{t("contact.subject")}</Label><Input required maxLength={200} value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" className="mt-1.5" /></div>
                        <div><Label>{t("contact.message")}</Label><Textarea required maxLength={4000} rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" className="mt-1.5" /></div>
                        <Button type="submit" disabled={busy} className="w-full rounded-full" data-testid="contact-submit">{busy ? t("common.loading") : t("contact.send")}</Button>
                    </div>
                </form>
            </section>
        </MarketingShell>
    );
}
